import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import getSystemMessage from '@top/shared/src/Languages/helpers/getSystemMessage'
import COLORS from '@top/shared/src/style/colors'

import TimedOutIllustration from './TimedOutIllustration'

const TimedOutPage = () => {
  return (
    <Grid
      container
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      rowGap={{ xs: 4, md: 5 }}
      textAlign="center"
      bgcolor={COLORS.BACKGROUND}
      minHeight="100vh"
      p={{ xs: '1.5rem 1rem', md: '3rem 1.5rem' }}
    >
      <TimedOutIllustration />
      <Grid container flexDirection="column" alignItems="center" rowGap={{ xs: 1, md: 1.5 }}>
        <Typography
          component="h1"
          color={COLORS.TEXT_DARK}
          fontSize={{ xs: '1.5rem', md: '1.875rem' }}
          fontWeight="700"
          lineHeight="normal"
          fontFamily="Archivo"
          margin={0}
        >
          {getSystemMessage('error_pages.timed_out.title')}
        </Typography>
        <Typography
          color={COLORS.TEXT_DARK}
          fontSize={{ xs: '1rem', md: '1.125rem' }}
          fontWeight="400"
          lineHeight="normal"
          fontFamily="Archivo"
        >
          {getSystemMessage('error_pages.timed_out.description')}
        </Typography>
      </Grid>
    </Grid>
  )
}

export default TimedOutPage
